<template>
  <div class="mx-0 md:mx-5 my-5">
    <vs-row vs-type="flex" vs-justify="space-between">
      <vs-col
        class="mt-2 md:mt-0 pr-0 md:pr-1"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-sm="12"
        vs-lg="6"
      >
        <slot></slot>
      </vs-col>
      <vs-col
        class="pl-0 md:pl-1 mt-2 md:mt-0"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-sm="12"
        vs-lg="6"
      >
        <Popper :activePoper="activePoper" :active.sync="activePoper" :index="index" :timelineData="timelineData">
          <vs-button
            :disabled="timelineData.length === 0"
            class="w-full mr-0 md:mr-1"
            color="success"
            type="border"
            @click.stop="activePoper = !activePoper"
            >{{ $t(`MODULE.containe`) }} {{ totalQuestion(saveCreatedDependecies[this.question.name]) }} {{ $t(`MODULE.dependencies`) }}</vs-button
          >
        </Popper>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import Popper from "./Popper.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import { deleteDependenceChild } from "@/serviforms/designer/indexDB/dependencies.js";
export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  components: { Popper },
  data: () => ({
    activePoper: false
  }),
  computed: {
    ...mapState("resource", ["saveCreatedDependecies", "questionsByPage"]),
    ...mapGetters("resource", ["getAllQuestions"]),
    question() {
      return this.questionsByPage[this.index];
    },
    related() {
      return this.saveCreatedDependecies[this.question.name];
    },
    timelineData() {
      const timelineData = [];
      // console.log("MMMMMMMMMMMMMMMMMMMMMM ", this.related);
      if (this.related !== undefined) {
        for (var i in this.related) {
          const item = {
            color: "primary",
            id: i,
            title: this.getLabel(i),
            condition: `${this.question.name} igual a`,
            remove: id => this.removeQuestion(id),
            desc: this.isArray(this.related[i].answer || this.related[i].answers)
          };
          timelineData.push(item);
        }
      }

      return timelineData;
    }
  },
  methods: {
    ...mapActions("resource", ["getCreatedDependencies"]),
    /**
     * Obtiene el total de preguntas vinculdas a la dependencia
     * @param {Object} object - Objeto con todas las prguntas vinculadas a la dependencia.
     */
    totalQuestion(object) {
      if (object) {
        const keys = Object.keys(object);
        return keys.length;
      }
      return 0;
    },
    getLabel(name) {
      const question = this.getAllQuestions.find(question => question.name === name);
      if (question !== undefined && question.hasOwnProperty("label")) return question.label;
      return "";
    },
    isArray(item) {
      if (Array.isArray(item)) return item.join(" --- ");
      return item.toString();
    },
    /**
     * Desincula una pregunta de la dependencia.
     * @param {string} name
     */
    async removeQuestion(name) {
      await deleteDependenceChild(this.question.name, name);
      await this.getCreatedDependencies();
    }
  }
};
</script>

<style lang="scss" scoped></style>
